<template>
<div
  id="purchase-requests"
>
  <div class="modal" id="purchase-requests-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Purchase Requests</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body">
            <flash></flash>
            <spinner size="large" v-if="loading" />
            <ol
              v-if="requests && requests.length"
            >
              <li v-for="req in requests">
                <p>
                  <span>
                    {{ req.created_at }}
                    <span
                      class="badge badge-warning"
                    >
                      {{ requestStatus(req) }}
                    </span>
                  </span>
                  <pre v-html="req.request"></pre>
                </p>
              </li>
            </ol>
            <p
              class="alert alert-danger"
              v-else-if="requests"
            >
              No requests logged
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Close</button>
          </div>
      </div>
    </div>
  </div>

  <button
    type="button"
    :class="btnClasses"
    @click="getRequests"
    data-toggle="modal"
    data-target="#purchase-requests-modal"
  >
    Browser Request History
    <span
      class="badge badge-secondary"
    >
      Debug
    </span>
  </button>
</div>
</template>

<script>
import humanize from 'humanize-string'

import Flash from '@/components/Flash'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    return {
      requests: undefined,
      loading: false
    }
  },

  props: {
    'btnBlock': {
      type: Boolean
    },

    'lbl': {
      type: String,
      default: 'Recipient'
    },

    'purchaseId': {
      type: [ Number, String ],
      required: true
    }
  },

  components: {
    'flash': Flash,
    'spinner': Spinner
  },

  computed: {
    btnClasses () {
      let classes = [
        'btn', 'btn-warning', 'form-group'
      ]

      if (this.btnBlock) {
        classes.push('btn-block')
      } else {
        classes.push('btn-sm')
      }

      return classes.join(' ')
    }
  },

  methods: {
    getRequests () {
      this.loading = true
      this.apiGet(
        '/purchases/' + this.purchaseId + '/requests', undefined, true
      ).then((resp) => {
        this.requests = resp
      }).catch(this.$root.processErrors).finally(() => {
        this.loading = false
      })
    },

    requestStatus (req) {
      return humanize(req.purchase_request_status)
    }
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
  }
}

li {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseRequests.vue